RivalIQ.apps.CompanyProfile.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Overview = Marionette.CollectionView.extend({
        className: 'row',
        getChildView: function (channel) {
            const me = this;

            if (me.companyRecord.hasChannel(channel.get('source'))) {
                return views.Channel;
            }

            return views.EmptyPresence;
        },

        childViewOptions: function () {
            const me = this;

            return {
                companyRecord: me.companyData.get(me.companyId),
                companyData: me.companyData,
                companyId: me.companyId,
                isFollowing: me.isFollowing
            };
        },

        initialize: function (options) {
            const me = this;
            _.extend(me, options);
            me.companyRecord = me.companyData.get(me.companyId);
        }
    });

});
